import { render, staticRenderFns } from "./Mission.vue?vue&type=template&id=12b50038&scoped=true&"
import script from "./Mission.vue?vue&type=script&lang=js&"
export * from "./Mission.vue?vue&type=script&lang=js&"
import style0 from "./Mission.vue?vue&type=style&index=0&id=12b50038&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b50038",
  null
  
)

export default component.exports